import tippy from 'tippy.js';

let Tippys = tippy('[data-tippy-content]', {
    theme: 'dark',
    arrow: true,
    placement: 'top'
});

if (window.innerWidth <= 991) {
    Tippys.forEach((item) => {
        item.disable();
    });
}

export default Tippys;
